import React from "react";

function Job() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      fill="none"
      viewBox="0 0 24 25"
    >
      <path
        stroke="currentColor"
        strokeWidth="1.5"
        d="M2.58 8.768c-.071-.59-.106-.885-.057-1.126.142-.689.748-1.247 1.556-1.434.283-.065.638-.065 1.349-.065h13.144c.711 0 1.066 0 1.35.065.807.187 1.413.745 1.555 1.434.05.241.014.536-.057 1.126-.162 1.352-.92 2.091-2.369 2.517l-4.171 1.228c-1.426.42-2.139.63-2.88.63-.741 0-1.454-.21-2.88-.63l-4.171-1.228C3.5 10.86 2.742 10.12 2.579 8.768z"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M3.463 10.643l-.196 2.276c-.352 4.08-.528 6.119.6 7.421 1.129 1.303 3.072 1.303 6.957 1.303h2.352c3.885 0 5.828 0 6.957-1.303 1.128-1.302.952-3.342.6-7.421l-.196-2.276"
      ></path>
      <path
        stroke="currentColor"
        strokeWidth="1.5"
        d="M15.5 5.643l-.077-.265c-.385-1.32-.578-1.98-1.036-2.357-.458-.378-1.067-.378-2.285-.378h-.204c-1.218 0-1.827 0-2.285.378-.458.377-.65 1.037-1.036 2.357l-.077.265"
      ></path>
    </svg>
  );
}

export default Job;
